<template>
  <div class="subscription-box__title-box">
    <h1 class="subscription-box__title">Full Access Plan</h1>
    <p>You have full access to Shortform through your organization.</p>
  </div>
</template>

<style scoped lang="scss">
.subscription-box {
  &__title-box {
    padding-top: 40px;
    padding-bottom: 40px;
    p {
      font-size: 24px;
    }
  }
}

.night-mode .subscription-box {
  &__title-box {
    p {
      color: $c-black-11;
    }
  }
}
</style>
